import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {filter} from 'rxjs/operators'
import { environment } from 'src/environments/environment';
declare var gtag;
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private authService:AuthService,private activatedRoute: ActivatedRoute, private router: Router){
     const navEndEvents =router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );
    navEndEvents.subscribe((event :any) =>{
      const rt = this.getChild(this.activatedRoute);  
        rt.data.subscribe(data => {
          gtag("config", environment.prod_tracking, {
            'user_id': localStorage.getItem("email"),
            'page_path': event.urlAfterRedirects,
            'page_title': data.title,
            'user_name':localStorage.getItem('username'),
            'role':localStorage.getItem('role')
          });
        });
    })
  }
  getChild(activatedRoute: ActivatedRoute) {  
    if (activatedRoute.firstChild) {  
      return this.getChild(activatedRoute.firstChild);  
    } else {  
      return activatedRoute;  
    }  
  } 
  ngOnInit(): void {
    this.authService.autoAuthUser();
  }
}
